import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Helmet } from '../../../../modules/foundation/components/HelmetProvider';
import { ImagePropType } from '../../../../services/proptypes';
import { getImageSrc } from '../../../../utils/images';
import { addIfNotEmpty } from '../LocalBusinessSchema/LocalBusinessSchema.utils';
import { formatServiceOffers, formatServiceOutput } from '../transformers/service';
import { BusinessProviderPropType } from '../types/business';
import { getBusinessSchemaType } from '../utils/business';
import { getImage } from '../utils/image';
import { markdownToPlainText } from '../utils/markdown';
var defaultProps = {
  description: '',
  image: null,
  prices: [],
  duration: '',
  durationUnit: ''
};
export default function ServiceItemSchema(_ref) {
  var businessName = _ref.businessName,
    businessCategories = _ref.businessCategories,
    name = _ref.name,
    categoryName = _ref.categoryName,
    description = _ref.description,
    image = _ref.image,
    prices = _ref.prices,
    duration = _ref.duration,
    durationUnit = _ref.durationUnit;
  var schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: categoryName,
    name: name,
    description: markdownToPlainText(description),
    provider: {
      '@type': getBusinessSchemaType(businessCategories),
      name: businessName
    }
  };
  schema = addIfNotEmpty(schema, 'image', getImageSrc(getImage(image)));
  schema = addIfNotEmpty(schema, 'serviceOutput', formatServiceOutput({
    duration: duration,
    durationUnit: durationUnit
  }));
  schema = addIfNotEmpty(schema, 'offers', formatServiceOffers({
    prices: prices
  }));
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
}
ServiceItemSchema.defaultProps = defaultProps;